'use client';

import { Tabs } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { useFeatureFlagsContext } from '../../app/providers/FeatureFlagsProvider';

export function FindingDetailsTabTriggers() {
  const t = useTranslations('designSystem.findings.findingDrawer.tabs');
  const { featureFlags } = useFeatureFlagsContext();

  return (
    <Tabs.List justifyContent="flex-start" px="4">
      <Tabs.Trigger value="overview" fontSize="sm" px="3" py="2">
        Overview
      </Tabs.Trigger>
      <Tabs.Trigger value="resolution" fontSize="sm" px="3" py="2">
        Resolution
      </Tabs.Trigger>
      <Tabs.Trigger value="business-impact" fontSize="sm" px="3" py="2">
        Business Impact
      </Tabs.Trigger>
      <Tabs.Trigger value="audit" fontSize="sm" px="3" py="2">
        Audit Trail
      </Tabs.Trigger>
      {featureFlags.FINDING_CVSS_DETAILS_TAB_ENABLED ? (
        <Tabs.Trigger value="cvss" fontSize="sm" px="3" py="2">
          {t('cvss.title')}
        </Tabs.Trigger>
      ) : null}
      <Tabs.Indicator />
    </Tabs.List>
  );
}
